import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'sleep_hours'

const ANSWER_TEXTS = {
  'less-than-5': 'Less than 5',
  '5-6': '5-6',
  '7-8': '7-8',
  'more-than-8': 'More than 8',
}

const answers: AnswerType[] = [
  {
    emoji: '😵',
    title: 'pages.onboarding.sleep.options.lessThanFive',
    value: 'less-than-5',
  },
  {
    emoji: '😐',
    title: 'pages.onboarding.sleep.options.fiveToSix',
    value: '5-6',
  },
  {
    emoji: '😊',
    title: 'pages.onboarding.sleep.options.sevenToEight',
    value: '7-8',
  },
  {
    emoji: '😴',
    title: 'pages.onboarding.sleep.options.moreThanEight',
    value: 'more-than-8',
  },
]

export default function SleepHoursPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How many hours do you sleep per night?',
      answer_key: answerValue,
      answer: ANSWER_TEXTS[answerValue as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.sleep.heading"
      preselectedValue={preselectedValue}
      onSubmit={onSubmit}
    />
  )
}
